/* global   */
import * as React from "react";
import { IStackStyles, Stack } from "@fluentui/react";
import { OrdersTable } from "./OrdersTable/OrdersTable";
import { OrderTransferer } from "./OrderTransferer";
import { OrderSyncer } from "./OrderSyncer";
import { OrderDisplay } from "./OrdersTable/OrdersTableDef";
import { useEffect, useState } from "react";
import { useLoadLocalOrderLines } from "../hooks/useLoadOrderLies";
import { useLoadProjectMeta } from "../hooks/useLoadProjectMeta";
export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}
const stackStyles: Partial<IStackStyles> = { root: { height: 34, marginTop: ".5rem" } };

export const OrderView = () => {
  const { reload } = useLoadLocalOrderLines();
  const [error, setError] = useState("");

  useLoadProjectMeta();

  useEffect(() => {
    window.addEventListener("focus", reload);
    return () => {
      window.removeEventListener("focus", reload);
    };
  }, []);

  const [selected, setSelectedLines] = useState<OrderDisplay[]>([]);
  return (
    <>
      <OrdersTable onSelectionChange={setSelectedLines} />
      {error && <div style={{ color: "red", textAlign: "center" }}>{error}</div>}
      <Stack horizontal styles={stackStyles} verticalAlign="center" horizontalAlign="center">
        <OrderTransferer onError={setError} orders={selected} />
        <OrderSyncer onError={setError} />
      </Stack>
    </>
  );
};
